import { useEffect, useRef, useState, useLayoutEffect } from "react";
import { coreFieldStyles, DynamicSelectorButtons, Field, Input, Textarea } from "../../../components/forms";
import { ButtonLight } from "../../../components/ctas";
import { useAppContext } from "../../../contexts/app";
import { FieldsetWrapperFS, makeValues, QCSubNav } from "../unit/page";
import { formatPhoneNumber, removeSpecialCharacters } from "../../../utils/formatting";
import { UseGoogleSheet } from "../../../hooks/UseGoogleSheets";
import { generateUUID } from "../../../utils/global";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { removeUnderscore } from "../../dashboard/qc/page";
import { CheckBox } from "../qc/page";

export const customerFormData = [
	{ name: "Business Name", description: "Name of purchasing/leasing business" },
	{ name: "Primary Email", description: "Customer's primary email", type: "email" },
	{ name: "Primary Phone", description: "Customer's primary phone number", filter: "phone", type: "tel", max: "14" },
	{ name: "Customer Name", description: "Name of purchasing/leading customer" },
	{ name: "Customer Address", description: "Name of purchasing/leading customer", type: "textarea" },
	{ name: "Tax Exempt", description: "Customer is tax exempt", type: "checkbox" },
	{ name: "Notes", description: "Notes on the customer", type: "textarea" },

]


export default function Customer() {
	const { id } = useParams();
	const appContext = useAppContext();
	const formRef = useRef();
	const [values, setValues] = useState({});
	const [rows, setRows] = useState([]);
	const [rowsOfUnits1, setRowsOfUnits1] = useState([]);
	const [qcItems, setQcItems] = useState([]);
	const { loadSheet, sheetRows, setRow, addRow, saveRow } = UseGoogleSheet({ spreadsheetId: process.env.REACT_APP_FS_CUSTOMER });
	const [editMode, setEditMode] = useState(false);
	const [uuid, setUuid] = useState(null);
	const { currentUser } = useAuth();
	const navigate = useNavigate();
	const [fields, setFields] = useState(customerFormData);

	const addRowToSheet = (obj, message = "Added row to sheet") => {
		return new Promise((resolve, reject) => {
			addRow(obj);
			resolve(message);
		});
	}

	const updateRowInSheet = (obj, message = "Updated row in sheet") => {
		return new Promise((resolve, reject) => {
			loadSheet(true).then((sheets) => {
				// let row = sheets?.find(row => row._rowNumber === obj.index);
				let row = sheetRows?.find( row => row.get('UUID') === obj?.UUID  );

				if (row) {
					const promises = Object.keys(obj).map(key => setRow(row, key, obj[key]));
					Promise.all(promises).then(() => {
						saveRow(row);
						resolve(message);
					});
				} else {
					alert("Could not locate the row")
				}
			});
		});
	}

	const saveSuccess = (target = null, url = null) => {
		if (target) {
			setTimeout(() => {
				target?.classList.remove("_loading")
				target?.classList.add("_success");
				setTimeout(() => {
					target?.classList.remove("_success");
					setEditMode(true);

					if (url) {
						window.scrollTo(0, 0);
						window.location.href = url;
					}
				}, 1000);
			}, 750);
		}
	}

	const handleField = (e) => {
		const temp = e.target.value;
		setValues((prev) => ({ ...prev, [e.target.name]: temp }));
	}

	const handleCheckbox = () => {
	}

	const handleSave = (e, update = editMode) => {
		if (e) e.preventDefault();

		const target = e?.target;
		if (target) target.classList.add("_loading");

		// Construct the tempEntries object with updatedValues
		const tempEntries = update
			? {
				...values, // Use updatedValues here
				"Updated On": new Date().toISOString(),
				"Updated By": `${currentUser.userinfo ? currentUser.userinfo?.name : 'Unknown'}`,
			}
			: {
				...values, // Use updatedValues here
				"UUID": uuid,
				"Created On": new Date().toISOString(),
				"Updated On": new Date().toISOString(),
				"Created By": `${currentUser.userinfo ? currentUser.userinfo?.name : 'Unknown'}`,
				"Updated By": `${currentUser.userinfo ? currentUser.userinfo?.name : 'Unknown'}`,
			};

		const entries = removeUnderscore(tempEntries);

		if (update) {
			// Update row
			updateRowInSheet(entries, `Updated row ${JSON.stringify(entries, null, 2)} in sheet`).then((message) => {
				console.log(message);
				saveSuccess(target);
			});
		} else {
			// Add new row
			addRowToSheet(entries, `Added row ${JSON.stringify(entries, null, 2)} in sheet`).then((message) => {
				console.log(message);
				saveSuccess(target);

				document.querySelector("html").classList.add("reloading");

				setTimeout(() => {
					alert("Great success!\nRedirecting to the new URL...");
					document.querySelector("html").classList.remove("reloading");
					// Redirect to the new URL
					window.location.href = `/fs/customer/${uuid}`;
					window.scrollTo(0, 0);
				}, 1500);
			});
		}
	}


	const handleChange = (e, filter) => {
		if (e && filter) {
			if (filter === "phone") {
				const formattedValue = formatPhoneNumber(e.target.value.replaceAll(" ", "").replaceAll("-", "").replaceAll("(", "").replaceAll(")", ""));
				setValues((prev) => ({ ...prev, [e.target.name]: formattedValue }));
				// e.target.value = formattedValue;
			}
		}
	}

	//Loads the sheet and sets the values, otherwise creates new row (sets UUID)
	useLayoutEffect(() => {
		loadSheet(true).then((sheets) => {
			setRows(sheets);
			setRowsOfUnits1(sheets);

			if (id) {
				let row = sheets?.find(row => row.get('UUID') === id.toString());
				const tempUUID = row.get('UUID');
				setUuid(tempUUID);
				setValues({
					"UUID": tempUUID,
					"Primary_Phone": row.get('Primary Phone'),
					"Primary_Email": row.get('Primary Email'),
					"Business_Name": row.get('Business Name'),
					"Customer_Name": row.get('Customer Name'),
					"Tax_Exempt": row.get('Tax Exempt'),
					"Customer_Address": row.get('Customer Address'),
					"Notes": row.get('Notes'),
				});
				setEditMode(true);
			} else {
				setUuid(generateUUID());
			}
		});
	}, []);


	useEffect(() => {
		console.log(values);
	}, [values]);


	return <>

		<div className="tw-w-full tw-px-40d tw-flex tw-space-x-40d">
			<form ref={formRef} className="tw-w-full tw-space-y-40px tw-pb-60px">

				{/* { editMode ? <>
					<SelectUnit editMode={ editMode} values={ values } setValues={ setValues } uuid={ values.UUID } model={ values.Model } name={ values?.["Unit Name"] } vin={ values?.VIN} qcItems={ qcItems }></SelectUnit>
				</> : <>
					<SelectUnit values={ values } setValues={ setValues } qcItems={ qcItems }></SelectUnit>
				</>} */}

				{/* { customerFormData && values?.UUID && <> */}
				<div className="tw-space-y-30px">

					<div className="tw-space-y-20px">
						<FieldsetWrapperFS title={"Customer"}>
							{customerFormData.map((item, index) => {
								const tempID = item.name.replaceAll(" ", "_");
								return <fieldset className="tw-flex tw-flex-col tw-w-full" key={`checkbox_pdi_${index}`}>
									<label htmlFor={tempID} className="tw-uppercase tw-tracking-[.1em] tw-text-[0.9em] tw-w-full tw-font-quaternary tw-flex tw-flex-col [&_>span]:tw-w-full tw-font-quaternary-normal">
										<span>
											{item.name}
										</span>
										{item.description && <span className="tw-normal-case tw-text-[.75em] tw-text-white/60">
											{item.description}
										</span>}
									</label>
									{ item.type === "checkbox" ? <DynamicSelectorButtons values={ values } setValues={ setValues } value={values[tempID] || ""} id={tempID} obj={[{"key": "Tax_Exempt", "value": "N/A", "src": null }, {"key": "Tax_Exempt", "value": "Yes", "src": null }, {"key": "Tax_Exempt", "value": "No", "src": null }]} /> : <Field maxLength={item.max || null} type={item.type || "text"} id={tempID} value={values[tempID] || ""} onInput={handleField} onChange={e => handleChange(e, item.filter || false)} />  }
								</fieldset>
							})}
						</FieldsetWrapperFS>
						<div className="tw-w-full tw-flex tw-justify-end">
							<ButtonLight type="submit" className="tw-uppercase" default onClick={handleSave}>
								<span className="tw-text-[1.5em] tw-py-5em tw-px-20em tw-w-full tw-flex tw-items-center tw-justify-center">
									<span>
										Submit
									</span>
								</span>
							</ButtonLight>
						</div>
					</div>
				</div>
			</form>
		</div>
	</>
}
